import React, { Component } from 'react';
import './Register.scss';
import { Link } from "react-router-dom";
import Card from '../components/Card';
import Actions from '../actions/api';
import Alert from 'react-bootstrap/Alert';
import ButtonLoader from '../components/ButtonLoader';
import { Redirect } from "react-router-dom";
import Logo from '../img/logo2.png';
import PasswordStrengthBar from 'react-password-strength-bar';

const LinkState = require('../helpers/link-state');

let errorTimeout;
export default class Register extends Component {
  state = {
    email: '',
    password: '',
    passwordConfirm: '',
    phone: '',
    full_name: '',
    processing: false,
    redirect: '',
    error: '',
    showPassword: false,
    showPasswordConfirm: false
  };

  async doSignup(event) {
    event.preventDefault();
    event.stopPropagation();

    if (!this.state.email) {
      return this.setState({
        error: 'Please enter your email',
      });
    }

    if (!this.state.password) {
      return this.setState({
        error: 'Please enter your password',
      });
    }

    if (this.state.password !== this.state.passwordConfirm) {
      return this.setState({
        error: 'Please make sure your passwords match',
      });
    }

    const validPassword = this.state.password.length >= 6 && this.state.password.match(/[a-z]/) && this.state.password.match(/[A-Z]/) && this.state.password.match(/\d/);


    if (!validPassword) {
      return this.setState({
        error: 'Password must be at least 6 characters with at least one uppercase and one number',
      });
    }

    if (!this.state.phone) {
      return this.setState({
        error: 'Please enter your phone number',
      });
    }

    if (!this.state.full_name) {
      return this.setState({
        error: 'Please enter your name',
      });
    }

    this.setState({
      processing: true,
    });

    Actions.post('users/register/', {
      email: this.state.email,
      password: this.state.password,
      phone: this.state.phone.replace(/\D/g,''),
      full_name: this.state.full_name,
    }).then(response => {
      window.bvSignedUp = true;
      this.setState({
        redirect: '/',
      });
    }).catch(error => {
      this.setState({
        processing: false,
        error,
      });
    })
    return false;
  }

  toggleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  toggleShowPasswordConfirm() {
    this.setState({ showPasswordConfirm: !this.state.showPasswordConfirm });
  }

  render () {

    if (this.state.redirect) {
      return (
        <Redirect to={this.state.redirect} />
      );
    }

    let alert = null;

    if (this.state.error) {

      if (errorTimeout) {
        clearTimeout(errorTimeout);
      }

      alert = (
        <Alert variant="danger">
          {this.state.error}
        </Alert>
      );
      errorTimeout = setTimeout(() => {
        this.setState({
          error: '',
        });
      }, 3e3);
    }

    let buttonText = (<span>Create Account</span>)

    if (this.state.processing) {
      buttonText = (<ButtonLoader />);
    }

    return (
      <div className="register container">
        {alert}
        <div className="row">
          <div className="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
            <Card>
              <div className="header__logo remove-pad">
                <Link to="/">
                  <img src={Logo} alt="BarView"/>
                </Link>
              </div>
              <p>Enter your information below in order to create your account</p>
              <form onSubmit={this.doSignup.bind(this)} method="post">
                <input
                  className="form-control"
                  type="text"
                  id="email"
                  name="email"
                  value={this.state.email}
                  onChange={LinkState.bind(this)}
                  placeholder="Email Address"
                />

                <input
                  className="form-control"
                  type="text"
                  id="full_name"
                  name="full_name"
                  value={this.state.full_name}
                  onChange={LinkState.bind(this)}
                  placeholder="Full Name"
                />

                <input
                  className="form-control"
                  type="text"
                  id="phone"
                  name="phone"
                  minlength="10"
                  value={this.state.phone}
                  onChange={LinkState.bind(this)}
                  placeholder="Phone Number"
                />
                <div className="input-wrapper">
                <input
                  className="form-control"
                  type={this.state.showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={this.state.password}
                  onChange={LinkState.bind(this)}
                  placeholder="Password"
                />
                <i className={`fa ${this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'} text-white password-icon`} onClick={this.toggleShowPassword.bind(this)}></i>
                </div>
                <PasswordStrengthBar password={this.state.password} />

                <div className="input-wrapper">
                <input
                  className="form-control"
                  type={this.state.showPasswordConfirm ? "text" : "password"}
                  id="passwordConfirm"
                  name="passwordConfirm"
                  value={this.state.passwordConfirm}
                  onChange={LinkState.bind(this)}
                  placeholder="Confirm Password"
                />
                <i className={`fa ${this.state.showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'} text-white password-icon`} onClick={this.toggleShowPasswordConfirm.bind(this)}></i>
                </div>

                <button
                  type="submit"
                  className="btn btn--primary btn--large mt-4"
                >
                  {buttonText}
                </button>
              </form>
            </Card>
          </div>
        </div>
      </div>
    )
  }
}